import axios from "axios";
import { allEventsURL, ackAlarmURL, systemURL, traducirEvento } from "@/constants";

export default {
    name: "resumen",
    components: {},
    data() {
        return {
            headers: [
                { text: "Value", align: "left", value: "texto" },
                { text: "Date", value: "fecha" },
                { text: "Acknowledged by", value: "aceptada_por" },
                { text: "Acknowledged date", value: "aceptada_fecha" }
            ],
            local: "",
            descripcion: "",
            soloPendientes: false,
            alertas: []
        };
    },

    computed: {
        algunaAlarmaPendiente() {
            return this.alarmasPendientes > 0;
        },

        alarmasPendientes() {
            return this.alertas.filter(x => !x.aceptada).length;
        },

        loggedIn() {
            return localStorage.loggedIn;
        },

        alertasFiltradas() {
            if (this.soloPendientes) {
                return this.alertas.filter(alerta => !alerta.aceptada_por);
            } else {
                return this.alertas;
            }
        }
    },

    async mounted() {
        if (!localStorage.loggedIn) {
            const loginpath = window.location.pathname;
            this.$router.push({ name: "acceso", query: { redirect: loginpath } });
        }
        this.cargarDatos();
    },

    methods: {
        async cargarDatos() {
            const systemId = this.$route.params.systemId;
            try {
                const promise1 = axios.get(systemURL(localStorage.userToken, systemId));
                const promise2 = axios.get(allEventsURL(localStorage.userToken, systemId));

                const datos1 = await promise1;
                const datos2 = await promise2;

                const result1 = datos1.data[0] || {};
                const result2 = datos2.data || [];

                this.systemId = systemId;
                this.local = result1.fantasy_name;
                this.descripcion = result1.system_description;

                this.alertas = result2
                    .map(r => ({
                        texto: traducirEvento(r.event_value),
                        fecha: r.published_at,
                        aceptada: r.ack === "1",
                        aceptada_por: r.ack_by,
                        aceptada_fecha: r.ack_date,
                        id: r.event_id
                    }))
                    .sort((a, b) => (a.fecha > b.fecha ? -1 : 1));
            } catch (e) {
                window.console.log("ERROR!!", e);
                const loginpath = window.location.pathname;
                this.$router.push({ name: "acceso", query: { redirect: loginpath } });
            }
        },

        async aceptar(s) {
            try {
                await this.cancelarAlarma(s.item.id);
                await this.sleep(500);
                this.cargarDatos();
            } catch (e) {
                window.console.log("ERROR!!", e);
            }
        },

        async aceptarTodosClick() {
            //const promesas = this.alertas.filter(x => !x.aceptada).map(y => this.cancelarAlarma(y.id));
            try {
                //await Promise.all(...promesas);
                await this.cancelarTodasAlarmas(this.systemId);
                await this.sleep(1000);
                this.cargarDatos();
            } catch (e) {
                window.console.log("ERROR!!", e);
                const loginpath = window.location.pathname;
                this.$router.push({ name: "acceso", query: { redirect: loginpath } });
            }
        },

        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        cancelarAlarma(alertid) {
            return axios.post(
                ackAlarmURL(),
                {
                    token: localStorage.userToken,
                    id: alertid
                },
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            );
        },

        cancelarTodasAlarmas(systemid) {
            return axios.post(
                ackAlarmURL(),
                {
                    token: localStorage.userToken,
                    system_id: systemid
                },
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            );
        },

        volverClick() {
            //this.$router.go(-2);
            this.$router.back();
        }
    }
};
